// Generated by `pnpm ops:deploy`. Do not edit.
//
// Rewritten from the modules selected for this deployment. An unselected
// module is not imported here, which is what keeps it out of the bundle
// entirely rather than merely switched off inside it.

import type { BundledModule } from './registry-types';
import { manifest as dnsManifest } from '@dashboard/module-dns/manifest';
import { ui as dnsUi } from '@dashboard/module-dns/ui';
import { manifest as sesManifest } from '@dashboard/module-ses/manifest';
import { ui as sesUi } from '@dashboard/module-ses/ui';
import { manifest as sitesManifest } from '@dashboard/module-sites/manifest';
import { ui as sitesUi } from '@dashboard/module-sites/ui';

export const BUNDLED: readonly BundledModule[] = [
	{
		manifest: dnsManifest,
		ui: dnsUi,
	},
	{
		manifest: sesManifest,
		ui: sesUi,
	},
	{
		manifest: sitesManifest,
		ui: sitesUi,
	},
];
